import {createSlice, createAsyncThunk} from "@reduxjs/toolkit"

import {post, get} from "helpers/api"

export const initialState = {
	loading: false,
	hasErrors: false,
	fetchSesssionDataApiState: {
		isFetching: false,
		isSuccess: false,
		isError: false,
		message: "",
		data: [],
		total: 0
	},
	updateSessionsApiState: {
		isSuccess: false,
		isFetching: false,
		isError: false,
		message: ""
	},
	searchEmployersApiState: {
		isFetching: false,
		isSuccess: false,
		isError: false,
		message: "",
		data: []
	},
	listEmployersApiState: {
		isFetching: false,
		isSuccess: false,
		isError: false,
		message: "",
		data: []
	}
}

export const fetchSesssionData = createAsyncThunk(
	"session/fetchSesssionData",
	async ({limit, user, offset, search, token}, thunkAPI) => {
		let response = await get(
			`v2/bookings/additionalSessions?limit=${limit}&offset=${offset}&search=${search}&isAdmin=${
				user["https://app.uprise.co/app_metadata"].role === "admin"
			}`,
			{},
			{Authorization: `Bearer ${token}`}
		)

		if (response.status === 200) {
			return response
		} else {
			return thunkAPI.rejectWithValue("Error while Fetching Coach Availability")
		}
	}
)

export const updateSessions = createAsyncThunk(
	"session/updateSessions",
	async ({remarks, invoice, id, token}, thunkAPI) => {
		let response = await post(
			`v2/bookings/additionalSessions/update`,
			{remarks, invoice, id},
			{},
			{Authorization: `Bearer ${token}`}
		)

		if (response.error) {
			return thunkAPI.rejectWithValue("Error while Fetching Coach Availability")
		} else {
			return response
		}
	}
)

export const searchEmployers = createAsyncThunk("session/searchEmployers", async ({search, token}, thunkAPI) => {
	let response = await get(`v2/bookings/additionalSessions/${search}`, {}, {Authorization: `Bearer ${token}`})

	if (response.status === 200) {
		return response
	} else {
		return thunkAPI.rejectWithValue("Error while Fetching Employers")
	}
})

export const listEmployers = createAsyncThunk("session/listEmployers", async ({token}, thunkAPI) => {
	let response = await get(`v2/bookings/additionalSessions/list`, {}, {Authorization: `Bearer ${token}`})

	if (response.status === 200) {
		return response
	} else {
		return thunkAPI.rejectWithValue("Error while Fetching Employers")
	}
})

const sessionSlice = createSlice({
	name: "session",
	initialState: initialState,
	reducers: {
		clearSessionsApiState: state => {
			state.fetchSesssionDataApiState.isError = false
			state.fetchSesssionDataApiState.isSuccess = false
			state.fetchSesssionDataApiState.message = ""
			state.fetchSesssionDataApiState.data = []
			state.fetchSesssionDataApiState.total = 0
			return state
		},
		clearUpdateSessionsApiState: state => {
			state.updateSessionsApiState.isSuccess = false
			state.updateSessionsApiState.isError = false
			state.updateSessionsApiState.message = ""
			return state
		}
	},
	extraReducers: {
		[fetchSesssionData.pending]: state => {
			state.fetchSesssionDataApiState.isFetching = true
		},
		[fetchSesssionData.rejected]: (state, {payload}) => {
			state.fetchSesssionDataApiState.isFetching = false
			state.fetchSesssionDataApiState.isError = true
			state.fetchSesssionDataApiState.message = payload?.error?.message || "Error, please contact tech support"
		},
		[fetchSesssionData.fulfilled]: (state, {payload}) => {
			state.fetchSesssionDataApiState.total = payload.totalCount
			state.fetchSesssionDataApiState.data = payload.data
			state.fetchSesssionDataApiState.isFetching = false
			state.fetchSesssionDataApiState.isError = false
			state.fetchSesssionDataApiState.isSuccess = true
		},
		[updateSessions.pending]: state => {
			state.updateSessionsApiState.isSuccess = false
			state.updateSessionsApiState.isFetching = true
		},
		[updateSessions.rejected]: (state, {payload}) => {
			state.updateSessionsApiState.isSuccess = false
			state.updateSessionsApiState.isError = true
			state.updateSessionsApiState.message = payload?.error?.message || "Error, please contact tech support"
		},
		[updateSessions.fulfilled]: (state, {payload}) => {
			const {id, remarks, invoice} = payload.data
			state.updateSessionsApiState.isFetching = false
			state.fetchSesssionDataApiState.data = state.fetchSesssionDataApiState.data.map(session => {
				if (session.id === id) return {...session, remarks, invoice}
				else return {...session}
			})
			state.updateSessionsApiState.isSuccess = true
			state.updateSessionsApiState.message = "Billing details saved successfully"
		},
		[searchEmployers.pending]: state => {
			state.searchEmployersApiState.isSuccess = false
			state.searchEmployersApiState.isFetching = true
		},
		[searchEmployers.rejected]: (state, {payload}) => {
			state.searchEmployersApiState.isSuccess = false
			state.searchEmployersApiState.isError = true
			state.searchEmployersApiState.message = payload?.error?.message || "Error, please contact tech support"
		},
		[searchEmployers.fulfilled]: (state, {payload}) => {
			state.searchEmployersApiState.isFetching = false
			state.searchEmployersApiState.data = payload.data
			// state.fetchSesssionDataApiState.data = payload.data
			state.searchEmployersApiState.isSuccess = true
			state.searchEmployersApiState.message = "Employers fetched successfully"
		},
		[listEmployers.pending]: state => {
			state.listEmployersApiState.isSuccess = false
			state.listEmployersApiState.isFetching = true
		},
		[listEmployers.rejected]: (state, {payload}) => {
			state.listEmployersApiState.isSuccess = false
			state.listEmployersApiState.isError = true
			state.listEmployersApiState.message = payload?.error?.message || "Error, please contact tech support"
		},
		[listEmployers.fulfilled]: (state, {payload}) => {
			state.listEmployersApiState.isFetching = false
			state.listEmployersApiState.data = payload.data
			state.listEmployersApiState.isSuccess = true
			state.listEmployersApiState.message = "Employers fetched successfully"
		}
	}
})

export const {clearSessionsApiState, clearUpdateSessionsApiState} = sessionSlice.actions

export const sessionDataSelector = state => state.session

export default sessionSlice
